import { useMutation, useQueryClient } from "@tanstack/react-query";
import { affiliateCodeKeys } from "Api/Queries/Affiliate/useAffiliateReferrerQuery";
import {
  type AffiliateReferrerDto,
  postLeadsReferrer,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (result: AffiliateReferrerDto) => void;
  onError?: (error: unknown) => void;
};

/** Attaches an affiliate code to the caller's Customer registration (last KYC step). */
export const useApplyCustomerAffiliateCodeMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((code: string) =>
      postLeadsReferrer({ code }),
    ),
    onSuccess: (result: AffiliateReferrerDto) => {
      queryClient.invalidateQueries({ queryKey: affiliateCodeKeys.all });
      onSuccess?.(result);
    },
    onError,
  });
};
